export class UnauthorizedController implements ng.IController {
    isInaccessible: boolean;
    isRules: boolean = false;

    static $inject = ['$stateParams'];

    constructor(private _$stateParams: angular.ui.IStateParamsService) {
    }

    $onInit() {
        this.isInaccessible = this._$stateParams['message'] === 'inaccessible';
        this.isRules = this._$stateParams['message'] === 'rules';
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/unauthorized/controllers/unauthorizedController.ts
 **/